<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Name Details</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <customer-name [customerNumberId]="customerNumberId" 
                    [customerNameId]="customerNameId"
                    [customerTypeId]="customerTypeId"
                    [isAka]="isAka">
    </customer-name>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
        <mvm-spinner-btn [btnClass]="'btn--accent'" 
                        [isDisabled]="disableSaveButton || !customerNameComponent || !customerNameComponent.nameForm || !customerNameComponent.nameForm.valid" 
                        [isLoading]="showButtonLoading" 
                        btnText="Save" 
                        (clicked)="saveName()"></mvm-spinner-btn>
    </div>
</div>